import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute, NavigationExtras} from '@angular/router';
import {NotifyxService} from '../../../services/notify/notifyx.service';
import {AuthService} from '../../../services/rest-api/auth.api.service';
import {TranslateService} from '@ngx-translate/core';
import {HssResponse} from '../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../services/rest-api/HssErrorResponse';
import {JwtHelperService} from '@auth0/angular-jwt';
import {InfoApiService} from '../../../services/rest-api/info.api.service';
import {NgbCarouselConfig} from '@ng-bootstrap/ng-bootstrap';
import {StorageService} from '../../../services/rest-api/storage.service';
import {environment} from '../../../../environments/environment';
import {SeoService} from '../../../services/seo/seo.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  isLoading;
  returnUrl: any;

  // Data stores
  newsData: any[] = [];
  eventsData: any[] = [];
  noticeData: any[] = [];
  newsLetterData: any[] = [];
  vacancyData: any[] = [];
  confData: any[] = [];
  booksData: any[] = [];
  slidesData: any[] = [];
  testimonialData: any[] = [];

  eventColor: string;
  images: any[] = [];

  //for loaders
  eventLoader: boolean = false;
  newsLoader: boolean = false;
  newsRepat: any[] = [1, 2, 3, 4];

  constructor(private router: Router,
              private route: ActivatedRoute,
              public notify: NotifyxService,
              private _authService: AuthService,
              private _info: InfoApiService,
              public translate: TranslateService,
              private storage: StorageService,
              private seo: SeoService,
              config: NgbCarouselConfig) {

    // Carousel config'
    config.interval = 3000;
    config.keyboard = true;
    config.pauseOnHover = true;
    config.animation = true;

    this.isLoading = false;
    this.eventColor = 'event_color';
    // load home main slider

  }

  ngOnInit(): void {

    this.seo.setMeta('Faculty of Humanities & Social Sciences - University of Ruhuna',
      'Faculty events, news, notices, vacancies, RASAS, RUICHSS, JSSHR, JFHSS, Research Journals')

    this.images = [944, 1011, 984].map((n) => 'assets/img/slide-1.jpg');
    // Authenticate and get the token
    // this.onLogin();
    this.storage.removeData('infoData'); // clear storage before set new values

    this.getFacultyById(environment.faculty_id);

    // Load active news
    this.getActiveNews();

    // Load active news
    this.getActiveEvents();

    // Load active notices
    this.getActiveNotices();

    // Load active vacancies
    this.getActiveVacancies();

    // Load active conferances
    this.getActiveConferences();

    // load active books and journals
    this.getActiveCBooks();
    // load testmoniels
    this.getTestimonial();

    this.getNewsLetters();

    // this.getHomeSlider();

  }


  onLogin(): void {
    const loginData = {
      email: '',
      password: '',
    };

    this._authService.login(loginData).subscribe(
      (response: HssResponse<any>) => {
        const data = response.body.data;
        const jwt = new JwtHelperService();
        const decodedToken = jwt.decodeToken(data.token);

        // Set User Data to Storage
        localStorage.setItem('userToken', data.token);
        // localStorage.setItem('firstName', data.user_data.first_name);
        // localStorage.setItem('lastName', data.user_data.user_name);
        // localStorage.setItem('profileImage', data.user_data.profile_image);
        // localStorage.setItem('prefLang', data.user_data.pref_lang);
        // Show the success message
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
        // this.notify.presentAlert(this.translate.instant('login.login_error'),this.translate.instant('login.'+message),'error');
      }
    );
  }

  // navigatePage(current: string, param?: number) {
  //   if (current === 'info') {
  //     const navigationExtras: NavigationExtras = {
  //       queryParams: {
  //         event: JSON.stringify(param)
  //       }
  //     };
  //     this.router.navigate(['/info/'],navigationExtras);
  //   }
  // }

  // Get News
  getActiveNews() {
    this.newsLoader = true;
    this._info.getActiveInfo(1).subscribe(
      (response: HssResponse<any>) => {
        this.newsData = response.body;
        // Merge all and store to local
        this.mergeInfo(this.newsData);
        this.newsLoader = false;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get information data
  getActiveEvents() {
    this.eventLoader = true;
    this._info.getActiveInfo(2).subscribe(
      (response: HssResponse<any>) => {
        this.eventsData = response.body;
        // Merge all and store to local
        this.mergeInfo(this.eventsData);
        this.storage.setdata('eventsData', response.body);
        this.eventLoader = false;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get Notices data
  getActiveNotices() {
    this._info.getActiveInfo(3).subscribe(
      (response: HssResponse<any>) => {
        this.noticeData = response.body;
        this.mergeInfo(this.noticeData);
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  //Get all Newsletters
  getNewsLetters() {
    this._info.getActiveInfo(9).subscribe(
      (response: HssResponse<any>) => {
        this.newsLetterData = response.body;
        console.log('newsLetterData...', this.newsLetterData);
        this.mergeInfo(this.newsLetterData);
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get vacancies data
  getActiveVacancies() {
    this._info.getActiveInfo(4).subscribe(
      (response: HssResponse<any>) => {
        this.vacancyData = response.body;
        this.mergeInfo(this.vacancyData);
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get conferences data
  getActiveConferences() {
    this._info.getActiveInfo(5).subscribe(
      (response: HssResponse<any>) => {
        this.confData = response.body;
        this.mergeInfo(this.confData);
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get active books and journals
  getActiveCBooks() {
    this._info.getActiveInfo(6).subscribe(
      (response: HssResponse<any>) => {
        this.booksData = response.body;
        this.mergeInfo(this.booksData);
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }


  // Get testimonials
  getTestimonial() {
    this._info.getActiveInfo(7).subscribe(
      (response: HssResponse<any>) => {
        this.testimonialData = response.body;
        this.mergeInfo(this.testimonialData);
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  getFacultyById(id: number) {
    this._info.getFacultyById(id).subscribe(
      (response: HssResponse<any>) => {
        this.storage.setdata('facultyData', response.body);

        this.getHomeSlider(response.body[0].home_slider);
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // Get slider for home slider according to faculty
  getHomeSlider(sliderId: number) {

    const facultydata = this.storage.getData('facultyData');
    const faculty = facultydata ? JSON.parse(facultydata) : [];

    this._info.getSlides(faculty[0]?.home_slider).subscribe(
      (response: HssResponse<any>) => {
        this.slidesData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  mergeInfo(data: any) {
    const localInfo = this.storage.getData('infoData');
    const infoData = localInfo ? JSON.parse(localInfo) : [];
    const merged = [...infoData, ...data]

    this.storage.setdata('infoData', merged);
  }
}
